var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = void 0;
var Skeleton_1 = __importDefault(require("./Skeleton"));
exports.Skeleton = Skeleton_1.default;
exports.default = Skeleton_1.default;
//# sourceMappingURL=index.js.map